import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toggle-buttons";
import "./../../bindings/element";
import "./../../bindings/bao-upload";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";


///View Model for the Document Tab of the TaskView
class TaskDocument extends ChildTabViewModel {

    taskVM: KnockoutObservable<any>;

    constructor(taskVM: any, tabPage: any) {
        super(tabPage, parent);
        this.TabPage = tabPage;

        this.taskVM = ko.observable(taskVM);

        this.taskVM().SubTabsSaveFn.push(() => { return this.Save(); });

        this.DirtyFlag = this.taskVM().TabPage.DirtyFlag;

        this.PageIndex(0);
        this.PageSize(10);
        this.TotalRows(0);

        this._msgCancel = Bao.Session.GetMessage("msgCancel");
        this._msgOk = Bao.Session.GetMessage("msgOk");
        this._Subscriptions = [];
        this.InitializeDialogs();

        this.OriginalTabTitle = this.TabPage.Title();
        this.TotalRows.subscribe((value) => {
            if (value == null || value == 0) {
                this.TabPage.Title(this.OriginalTabTitle);
                return;
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + value + ")");
        });

        this._Subscriptions.push(this.taskVM().InstructionAttachment.subscribe(() => {
            this.UpdateReferenceDocumentCollection();
        }));

        this._Subscriptions.push(this.SelectedReferenceDocumentRow.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._Subscriptions.push(this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._Subscriptions.push(this.taskVM().IsHistory.subscribe(() => {
            this.SelectedReferenceDocumentRow(null);
            this.ToggleToolbarButtons();
        }));
    }

    public TabPage;
    public Dialog: BaoDialogViewModel;
    public LinkDialog: BaoDialogViewModel = new BaoDialogViewModel(Bao.Session.ApplicationName);

    public Template: KnockoutObservable<string> = ko.observable();
    public TemplateContext: KnockoutObservable<string> = ko.observable();

    public DirtyFlag: KnockoutObservable<boolean> = ko.observable();
    public IsHistory: KnockoutObservable<boolean> = ko.observable();

    public PageIndex: KnockoutObservable<number> = ko.observable();
    public PageSize: KnockoutObservable<number> = ko.observable();
    public TotalRows: KnockoutObservable<number> = ko.observable();

    public RenderElement: KnockoutObservable<any> = ko.observable();
    public SelectedReferenceDocumentRow: KnockoutObservable<any> = ko.observable();

    public Sorting: KnockoutObservableArray<any> = ko.observableArray();
    public DocumentCollection: KnockoutObservableArray<any> = ko.observableArray();
    public ToolbarButtons: KnockoutObservableArray<any> = ko.observableArray();

    private _msgCancel: KnockoutObservable<string> = ko.observable();
    private _msgOk: KnockoutObservable<string> = ko.observable();

    private OriginalTabTitle: KnockoutObservable<string> = ko.observable();

    private _Subscriptions: KnockoutSubscription[];

    public init() {
        this.UpdateReferenceDocumentCollection();
        this.ToggleToolbarButtons();
    }

    public Refresh() {
        var def = $.Deferred();
        Bao.post("Task/ResetSession", JSON.stringify({
            sessionTabId: this.taskVM().SessionTabId()
        }), () => {
            this.RefreshGrid().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }

    public StringIsNullOrEmpty(string) {
        if (string === null)
            return true;
        else if (string === "")
            return true;
        else if (typeof string === "undefined")
            return true;
        return false;
    }

    public CompleteCheck() {
        return true;
    }

    //Takes the attachment list from the Info Viewmodel and fetches it in a local list und calcualtes the row count
    public UpdateReferenceDocumentCollection() {
        let InstructionAttachmentBuffer: Array<any> = new Array();

        this.taskVM().InstructionAttachment().forEach(attachment => {
            if (attachment.DeleteInRevision() === null || attachment.DeleteInRevision() > this.taskVM().Revision()) {
                InstructionAttachmentBuffer.push(attachment);
            }
        })

        this.DocumentCollection([]);
        this.DocumentCollection(InstructionAttachmentBuffer);
        this.TotalRows(this.DocumentCollection().length);
    }

    public InitializeDialogs() {
        this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.Dialog.Width("450px");
        this.Dialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.Dialog.ViewModel().Description())) {
                    this.Dialog.IsLoading(true);
                    this.Dialog.ViewModel().Upload().then(() => {
                        this.Dialog.IsLoading(false);
                        this.Dialog.Close();
                        this.Refresh();
                    })
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgCancel, () => { this.Dialog.Close(); })
        ]);

        this.LinkDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.LinkDialog.Width("450px");
        this.LinkDialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.LinkDialog.ViewModel().Description())) {
                    this.LinkDialog.IsLoading(true);
                    let item = this.LinkDialog.ViewModel();
                    let model = ko.map.toJS(item);
                    this.AddTaskDocument(model, this.taskVM().InstructionId()).then(() => {
                        this.LinkDialog.IsLoading(false);
                        this.LinkDialog.Close();
                    });
                } else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgCancel, () => { this.LinkDialog.Close(); })
        ]);
    }

    //Opens the Dialog for attaching Documents
    public ShowTaskDocumentDialog(instructionId, instructionAttachmentId) {
        return Bao.post("Task/ShowTaskDocumentDialog", JSON.stringify({
            sessionTabId: this.taskVM().SessionTabId(),
            instructionId: instructionId,
            InstructionAttachmentId: instructionAttachmentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.Upload = function () { };
            vm.SelectedFiles = ko.observableArray<string>();
            vm.IsEdit = instructionAttachmentId != null;
            vm.DocumentType = 0;
            if (instructionAttachmentId != null) {
                vm.UploadUrl = 'Task/UploadAttachment?sessionTabId=' + this.taskVM().SessionTabId() + '&TaskId=' + instructionId + '&InstructionAttachmentId=' + instructionAttachmentId;
            }
            else {
                vm.UploadUrl = 'Task/UploadAttachment?sessionTabId=' + this.taskVM().SessionTabId() + '&TaskId=' + instructionId;
            }
            this.Dialog.ViewModel(vm);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
        });
    }

    //Opens the Dialog for attaching Links
    public ShowTaskLinkDialog(instructionId, instructionAttachmentId) {
        return Bao.post("Task/ShowTaskDocumentDialog", JSON.stringify({
            sessionTabId: this.taskVM().SessionTabId(),
            instructionId: instructionId,
            instructionAttachmentId: instructionAttachmentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.IsEdit = instructionAttachmentId != null;
            vm.DocumentType = 1;
            this.LinkDialog.ViewModel(vm);
            this.LinkDialog.Template(value.Message);
            this.LinkDialog.Open();
        });
    }

    //Updates the Attachment List of the Instruction ViewModel
    public RefreshGrid() {
        this.TabPage.IsLoading(true);
        return Bao.post("Task/SearchTaskAttachmentCollection", JSON.stringify({
            sessionTabId: this.taskVM().SessionTabId(),
            instructionId: this.taskVM().InstructionId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedReferenceDocumentRow(null);
            this.TotalRows(0);
            this.taskVM().InstructionAttachment([]);
            if (searchResult != null && searchResult.Models != null) {
                ko.map.fromJS(searchResult.Models, this.taskVM().InstructionAttachment);
            }
        });
    }

    public AddTaskDocument(model, instructionId) {
        this.TabPage.IsLoading(true);
        return Bao.post("Task/AddTaskAttachment", JSON.stringify({
            sessionTabId: this.taskVM().SessionTabId(),
            referenceDocumentModel: ko.map.toJS(model),
            instructionId: instructionId
        }), () => {
            this.taskVM().TabPage.DirtyFlag(true);
            return this.Refresh();
        });
    }

    public DeleteTaskAttachment(InstructionAttachmentId) {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemReferenceDocument"), "yesno");
        this._Subscriptions.push(questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                return Bao.post("Task/RemoveAttachment", JSON.stringify({
                    sessionTabId: this.taskVM().SessionTabId(),
                    attachmentId: InstructionAttachmentId,
                    deleteInRevision: this.taskVM().Revision()
                }), () => {
                    this.taskVM().TabPage.DirtyFlag(true);
                    this.RefreshGrid();
                });
            }
        }));
    }

    public OpenAttachment = (instructionAttachmentId) => {
        if (this.SelectedReferenceDocumentRow().DocumentType() == 1) {
            this.OpenLink(this.SelectedReferenceDocumentRow().Link());
        }
        else {
            window.open(window.absolutePath + 'Task/DownloadAttachment/' + instructionAttachmentId);
        }
    };

    public OpenLink = (link) => {
        if (link.startsWith('http')) {
            window.open(link);
        }
        else {
            window.open('https://' + link);
        }
    }

    public ToolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddTaskDocument":
                this.ShowTaskDocumentDialog(this.taskVM().InstructionId(), null);
                break;
            case "AddTaskDocumentLink":
                this.ShowTaskLinkDialog(this.taskVM().InstructionId(), null);
                break;
            case "EditTaskDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    if (this.SelectedReferenceDocumentRow().DocumentType() == 1) {
                        this.ShowTaskLinkDialog(this.taskVM().InstructionId(), this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                    }
                    else {
                        this.ShowTaskDocumentDialog(this.taskVM().InstructionId(), this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                    }
                }
                break;
            case "DeleteTaskDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.DeleteTaskAttachment(this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                }
                break;
            case "DownloadTaskDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.OpenAttachment(this.SelectedReferenceDocumentRow().InstructionAttachmentId());
                }
                break;
        }
    };

    public ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            switch (button.ActionKey()) {
                case "AddTaskDocument":
                    button.Enabled(!this.taskVM().IsHistory())
                    break;
                case "AddTaskDocumentLink":
                    button.Enabled(!this.taskVM().IsHistory())
                    break;
                case "EditTaskDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined && !this.taskVM().IsHistory());
                    break;
                case "DeleteTaskDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined && !this.taskVM().IsHistory());
                    break;
                case "DownloadTaskDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined);
                    break;
            }
        });
    }
}
export default TaskDocument;